import { Link } from 'react-router';

import GrvFolderDownload from '../../../../assets/grv-folder-download.svg?react';
import { useEntitlements } from '../../../../contexts/useEntitlements';
import './DownloadDetailedSidebar.scss';

export const DownloadDetailedSidebar = ({
  currentArtifactKey,
}: {
  currentArtifactKey: string;
}) => {
  const { entitlements, isLoading } = useEntitlements();

  // TODO: Add in loading spinner for sidebar
  if (isLoading) {
    return (
      <div className="download-detailed-sidebar__loading">
        Loading artifacts...
      </div>
    );
  }

  if (!entitlements || entitlements.artifacts.length === 0) {
    return (
      <div className="download-detailed-sidebar__error">
        No artifacts available
      </div>
    );
  }

  const artifacts = entitlements.artifacts.map(
    ({ artifactName, artifactKey }) => {
      // add active class to row if artifact key prop matches artifact mapped to this row
      const isActive = artifactKey === currentArtifactKey;

      return (
        <li key={artifactKey}>
          <Link
            to={`/details/${artifactKey}`}
            aria-label={artifactName}
            data-testid={`download-detailed-sidebar__link-${artifactKey}`}
            {...(isActive && { 'aria-current': 'page' })}
          >
            <div
              className={`download-detailed-sidebar__level-two-row ${isActive ? 'download-detailed-sidebar__level-two-row-active' : ''}`}
            >
              <p className="download-detailed-sidebar__level-two-title">
                {artifactName}
              </p>
            </div>
          </Link>
        </li>
      );
    },
  );

  return (
    <nav
      className="download-detailed-sidebar__container"
      aria-label="Artifact navigation"
      data-testid="download-detailed-sidebar"
    >
      <div className="download-detailed-sidebar__level-one-container">
        <h2 className="download-detailed-sidebar__level-one-row download-detailed-sidebar__level-one-row-active">
          <GrvFolderDownload
            className="download-detailed-sidebar__level-one-icon"
            aria-hidden="true"
          />
          <span className="download-detailed-sidebar__level-one-title">
            Artifacts
          </span>
        </h2>
        <ul
          className="download-detailed-sidebar__level-two-container"
          role="list"
        >
          {artifacts}
        </ul>
      </div>
    </nav>
  );
};
